<template>
    <div class="fixwidth overflow_hide exampaper">
        <div class="fl paper">
            <!--标题开始-->
            <div class="title border">
                <div class="fl">
                    <span v-for="tp in topicType" :key="tp.name" :class="tp.active?'font-active':''" @click="checkType(tp)">{{tp.name}}</span>
                </div>
                <div class="submit fr">
                    <button @click="clickBtn">提交试卷</button>
                </div>
                <div class="time fr">
                    <img src="../../assets/image/clock.png">
                    <span>{{common.secondToString(clock)}}</span>
                </div>
                
            </div>
            <!--标题结束-->


            <!--题目开始-->
            <div class="topic border overflow_hide" style="border:1px solid #ddd;">
                <div v-for="(t,index) in topic" :key="index" v-if="t.creator===currentItemType">
                    <div class="question" v-if="t.creator==='填空题'" >
                        <span>{{index+1}}.</span>
                        <span v-html="t.questionView.name"/>
                        <span style="margin-left:20px;">({{t.score}}分)</span>
                    </div>
                    <div class="question" v-else>{{index+1}}.{{t.questionView.name}}<span style="margin-left:20px;">({{t.score}}分)</span></div>
                    <div v-if="t.creator==='单选题'||t.creator==='多选题'">
                        <img v-if="t.questionView.url!==null" v-lazy="serverIp+t.questionView.url">
                        <div class="answer" v-if="t.questionView.type==='单选题'||t.questionView.type==='多选题'">
                            <div v-for="(a,tindex) in t.questionView.answerItems" :key="index" @click="chooseAnswer(a,t.questionView)">
                                <span style="position: relative;left:0" class="input-radio" :class="a.active?'radio-active':''" >{{common.letter[tindex]}}</span>
                                <label :for="a.id">
                                    <span>{{a.content}}</span>
                                    <img v-if="a.url!==null" v-lazy="serverIp+a.url">
                                </label>
                            </div>
                        </div>
                    </div>
                    
                    <div v-if="t.creator==='判断题'">
                        <div  @click="judge(t.questionView,'1')">
                            <span style="position: relative;left:0" class="input-radio" :class="t.questionView.chooseAnswer==='1'?'radio-active':''">&nbsp;</span>
                            <label>正确</label>
                        </div>
                        <div  @click="judge(t.questionView,'0')">
                            <span style="position: relative;left:0" class="input-radio" :class="t.questionView.chooseAnswer==='0'?'radio-active':''">&nbsp;</span>
                            <label>错误</label>
                        </div>
                    </div>
                    
                    <div v-if="t.creator==='案例题'" >
                        <div style="padding-left:20px;" v-for="(c,index) in t.questionView.childList" :key="index">
                            <div>{{index+1}}.{{c.name}}</div>
                            <div class="caseAnswer" v-for="(a,index) in c.answerItems" @click="caseChoose(a,c)" :key="index">
                                <span style="position: relative;left:0" class="input-radio" :class="a.active?'radio-active':''" >{{common.letter[index]}}</span>
                                <label :for="a.id">
                                    <span>{{a.content}}</span>
                                    <img v-if="a.url!==null" v-lazy="serverIp+a.url">
                                </label>
                            </div>
                        </div>
                    </div>
    
                    <div v-if="t.creator==='填空题'">
                        <div style="padding-left:20px;" v-for="(c,index) in t.questionView.answerItems" :key="index">
                            <div>
                                <span class="input-radio">{{index+1}}</span>
                                <el-input style="width:calc(100% - 40px);" v-model="c.content"></el-input>
                            </div>
                        </div>
                    </div>
    
                    <div v-if="t.creator==='简答题'">
                        <!--<div style="padding-left:20px;" v-for="(c,index) in t.questionView.answerItems" :key="index">
                            <div>
                                <span class="input-radio">{{index+1}}</span>
                                <el-input style="width:calc(100% - 40px);" v-model="c.content"></el-input>
                            </div>
                        </div>-->
                        <div>
                            <el-input rows=9 v-model="t.qaanswer" type="textarea"></el-input>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
    export default {
        name: "ExamPaper",
        data(){
            return{
                topic:[],
                liNum:0,
                change:{
                    pre:require("../../assets/image/pre.png"),
                    next:require("../../assets/image/next.png")
                },
                topicType:[],
                current:1,
                clock:0,
                currentItemType:""
            }
        },
        created() {
            this.topic = JSON.parse(localStorage.getItem("examPaper"));
            this.parseJson(this.topic);
            setInterval(this.timePlus,1000);
            this.currentItemType = this.topicType[0].name;
            this.topicType[0].active = true;
            let data = new Date();
            let endTime = new Date(parseInt(localStorage.getItem("endTime")));
            this.clock = ((endTime.getTime() - data.getTime())/1000);
        },
        methods:{
            checkType(tp){
                this.currentItemType=tp.name;
                this.$nextTick(()=>{
                    this.topicType.forEach((t)=>{
						this.$set(t,"active",false);
                    });
					this.$set(tp,"active",true);
                })
            },
            setCache(obj){
                localStorage.removeItem("examPaper");
                localStorage.setItem("examPaper",JSON.stringify(obj));
            },
            pre(){
                if(this.current===1){
                    return false;
                }
                else this.current--;
            },
            next(){
                if(this.current===this.topic.length){
                    return false;
                }
                else this.current++;
            },
            li(index,t,tindex){
                this.currentItemType = this.topicType[tindex].name;    //根据题目点击切换
                this.topicType.forEach((t)=>{
                    this.$set(t,"active",false);
                });
                //let a = document.querySelector(".topic").childNodes;
                //this.$set(this.topicType[tindex],"active",true);
                let num=0;
                for(let i=0;i<tindex;i++){
                    num += this.topicType[i].size;
                }
                this.current=num+index+1;
            },
            //判断题选择
            judge(a,t){
                this.$nextTick(()=> {
                    this.$set(a,"chooseAnswer",t);
                });
                this.setCache(this.topic);
            },
            //案例题选择
            caseChoose(a,t){
                this.$nextTick( ()=> {
                    t.answerItems.forEach(a=>{
                        this.$set(a, 'active', false);
                    });
                    this.$set(a, 'active', true);
                    this.$set(t,"chooseAnswer",a.answerNo);
                });
                this.setCache(this.topic);
            },
            //选择题选择答案
            chooseAnswer(a,t){
                let arr= [];
                switch (t.type) {
                    case "单选题":
                        this.$nextTick( ()=> {
                            t.answerItems.forEach( (a)=>{
                                this.$set(a, 'active', false);
                            });
                            this.$set(a, 'active', true);
                            //this.$set(this.topic[this.current-1].questionView,"chooseAnswer",a.answerNo);
                            this.$set(t,"chooseAnswer",a.answerNo);
                        });
                        break;
                    case "多选题":
                        this.$nextTick(()=>{
                            this.$set(a,'active',!a.active);
                            for(let i in t.answerItems){
                                if(t.answerItems[i].active){
                                    arr.push(t.answerItems[i].answerNo)
                                }
                            }
                            this.$set(t,"chooseAnswer",arr.join(","));
                        });
                        break;
                }
                this.setCache(this.topic);
            },
            clickBtn(){
                //this.submitExam();
                this.$confirm('提交后无法修改，是否确认交卷?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.submitExam();
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消交卷'
                    });
                });
            },
            submitExam(){
                let examScore=0;
                let postData ={
                    examId:this.$route.params.id,
                    answerTime:this.common.formatDateAndTime(new Date(),"/"),
                    duration:  (new Date() - new Date(localStorage.getItem("examStartTime")))/1000,
                    score:0,
                    recordItems:[],
                    type:"exam"
                };
                for(let i in this.topic){
                    let correctAnswer=[];
                    switch (this.topic[i].questionView.type) {
                        case "单选题":
                            for(let j in this.topic[i].questionView.answerItems){
                                if(this.topic[i].questionView.answerItems[j].isTrue===1){
                                    correctAnswer[0] = this.topic[i].questionView.answerItems[j].answerNo;
                                }
                            }
                            if(correctAnswer[0] !== this.topic[i].questionView.chooseAnswer){
                                examScore +=0;
                                postData.recordItems.push(
                                    {
                                        questionId:this.topic[i].questionView.id,
                                        realAnswer:this.topic[i].questionView.chooseAnswer,
                                        isTrue:0,
                                        score:0
                                    }
                                )
                            }
                            else {
                                examScore +=this.topic[i].score;
                                postData.recordItems.push(
                                    {
                                        questionId:this.topic[i].questionView.id,
                                        realAnswer:this.topic[i].questionView.chooseAnswer,
                                        isTrue:1,
                                        score:this.topic[i].score
                                    }
                                )
                            }
                        break;
                        case"多选题":
                            //有选项没选
                            for(let j in this.topic[i].questionView.answerItems){
                                if(this.topic[i].questionView.answerItems[j].isTrue===1){
                                    correctAnswer.push(this.topic[i].questionView.answerItems[j].answerNo);
                                }
                            }
                            if(this.topic[i].questionView.chooseAnswer===undefined){
                                examScore +=0;
                                postData.recordItems.push(
                                    {
                                        questionId:this.topic[i].questionView.id,
                                        realAnswer:this.topic[i].questionView.chooseAnswer,
                                        isTrue:0,
                                        score:0
                                    }
                                )
                            }
                            //完全答对
                            else if(this.topic[i].questionView.chooseAnswer===correctAnswer.join(",")){
                                examScore += this.topic[i].score;
                                postData.recordItems.push(
                                    {
                                        questionId:this.topic[i].questionView.id,
                                        realAnswer:this.topic[i].questionView.chooseAnswer,
                                        isTrue:1,
                                        score:this.topic[i].score
                                    }
                                )
                            }
                            //答对部分
                                    //this.topic[i].questionView.chooseAnswer
                            else if(this.common.includes(correctAnswer,this.topic[i].questionView.chooseAnswer.split(","))&&correctAnswer!==this.topic[i].questionView.chooseAnswer.split(",")) {
                                examScore += this.topic[i].score/2;
                                postData.recordItems.push(
                                    {
                                        questionId:this.topic[i].questionView.id,
                                        realAnswer:this.topic[i].questionView.chooseAnswer,
                                        isTrue:2,
                                        score:this.topic[i].score/2
                                    }
                                )
                            }
                            //答错
                            else {
                                examScore +=0;
                                postData.recordItems.push(
                                    {
                                        questionId:this.topic[i].questionView.id,
                                        realAnswer:this.topic[i].questionView.chooseAnswer,
                                        isTrue:0,
                                        score:0
                                    }
                                )
                            }
                            break;
                        case "判断题":
                            if(this.topic[i].questionView.answer===this.topic[i].questionView.chooseAnswer){
                                examScore +=this.topic[i].score;
                                postData.recordItems.push(
                                    {
                                        questionId:this.topic[i].questionView.id,
                                        realAnswer:this.topic[i].questionView.chooseAnswer,
                                        isTrue:1,
                                        score:this.topic[i].score
                                    }
                                )
                            }
                            else {
                                examScore +=0;
                                postData.recordItems.push(
                                    {
                                        questionId:this.topic[i].questionView.id,
                                        realAnswer:this.topic[i].questionView.chooseAnswer,
                                        isTrue:0,
                                        score:0
                                    }
                                )
                            }
                            break;
                        case "案例题":
                            for(let j in this.topic[i].questionView.childList){
                                if(this.topic[i].questionView.childList[j].answer===this.topic[i].questionView.childList[j].chooseAnswer){
                                    examScore +=this.topic[i].score/(this.topic[i].questionView.childList.length);
                                    postData.recordItems.push(
                                        {
                                            questionId:this.topic[i].questionView.childList[j].id,
                                            realAnswer:this.topic[i].questionView.childList[j].chooseAnswer,
                                            isTrue:1,
                                            score:this.topic[i].score/(this.topic[i].questionView.childList.length)
                                        }
                                    )
                                }
                                else {
                                    examScore +=0;
                                    postData.recordItems.push(
                                        {
                                            questionId:this.topic[i].questionView.childList[j].id,
                                            realAnswer:this.topic[i].questionView.childList[j].chooseAnswer,
                                            isTrue:0,
                                            score:0
                                        }
                                    )
                                }
                            }
                            break;
                        case "填空题":
                            let blankAnswer = [];
                            for(let j in this.topic[i].questionView.answerItems){
                                blankAnswer.push(this.topic[i].questionView.answerItems[j].content);
                            }
                            postData.recordItems.push(
                                    {
                                        questionId:this.topic[i].questionId,
                                        realAnswer:blankAnswer===[]?"":blankAnswer.join(","),
                                        isTrue:0,
                                        score:0
                                    }
                            );
                            break;
                        case "简答题":
                            postData.recordItems.push(
                                    {
                                        questionId:this.topic[i].questionId,
                                        realAnswer:this.topic[i].qaanswer,
                                        isTrue:0,
                                        score:0
                                    }
                            );
                            break
                    }
                }
                postData.score=examScore;
                postData.creator = this.$store.getters.getToken.id;
                postData.type="exam";
                this.$json("/paperRecord","POST",postData).then(()=>{
                    this.$message("提交成功");
                    window.close();
                    //提交试卷后清空localStorage
                    localStorage.removeItem("examPaper");
                    localStorage.removeItem("examStartTime");
                    localStorage.removeItem("endTime");
                    //父页面执行刷新
                    //window.opener.location.href = window.opener.location.href;
                    window.opener.location.reload();
                })
            },
            //统计每个题目有多少道
            parseJson(json){
                let b ={};
                for(let i in json){
                    let id = json[i]['questionView']["type"];
                    if(b[id] === undefined)
                        b[id] = 1;
                    else
                        b[id] += 1;
                }
                for(let key in b){
                    this.topicType.push({"name":key,size:b[key]});
                }
            },
            timePlus(){
                this.clock--;
                if(new Date().getTime()>=localStorage.getItem("endTime")){
                    this.$message("考试时间结束，自动为您交卷");
                    this.submitExam();
                    localStorage.removeItem("endTime");
                }
            },
            signAnswer(){
                let node = document.querySelectorAll(".li");
                for(let i in node){
                    if(this.topic[i].judge==="correct"){
                        node[i].classList.add("correct");
                    }
                    else if(this.topic[i].judge==="incorrect"){
                        node[i].classList.add("incorrect");
                    }
                    else if(this.topic[i].judge==="half"){
                        node[i].classList.add("half");
                    }
                }
            }
        },
        mounted() {
            /*window.onbeforeunload=function(){
                return '确定离开?将不会保存试卷'
            }*/
        },
        watch:{
            'current'(){
                let a= document.querySelectorAll(".li");
                for(let i=0;i<a.length; i++){
                    a[i].classList.remove("radio-active");
                    if(i===this.current-1){
                        a[i].classList.add("radio-active");
                    }
                }
            }
        }
    }
</script>

<style scoped lang="less">
    @import '../../assets/css/paper.less';
</style>
